import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import axios from 'axios';

import Header from "./Header";
import Footer from "./Footer";

const Closed = () => {

    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        default:
            languageId = 1;
            language = "de";
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    return (
        <>
            <div className="page-container">
                <Header language={language} />

                <div className="mt-5 mb-4" style={{ padding: "2rem", textAlign: "center" }}>
                    <p dangerouslySetInnerHTML={{ __html: resources?.Closed }}></p>
                </div>

                <Footer language={language} pagePath="home" />
            </div>
        </>
    );
};

export default Closed;